import script from "./HomeAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeAdmin.vue?vue&type=script&setup=true&lang=js"

import "./HomeAdmin.vue?vue&type=style&index=0&id=4aaaa948&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aaaa948"]])

export default __exports__